var render = function render(_c,_vm){return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(_vm.props.value)?_c('img',_vm._g(_vm._b({staticStyle:{"height":"30px","width":"30px"},attrs:{"src":_vm.props.value,"aspect-ratio":"1"}},'img',attrs,false),on)):_c('i',[_vm._v("-")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.props.item.translation))])])
}
var staticRenderFns = []

export { render, staticRenderFns }